<div class="billing-report" [attr.data-automation-id]="automationId + '-container'">
    <div class="header-bar top" [attr.data-automation-id]="automationId + '-header'">
        <button type="button" [attr.data-automation-id]="automationId + '-save-button'" class="primary-button"
            (click)="saveChanges()" [disabled]="isDisabled()" *ngIf="hasPermissions">Save</button>
        <button type="button" [attr.data-automation-id]="automationId + '-discard-changes-button'"
            class="secondary-button" (click)="discardChanges()" [disabled]="isDisabled()" *ngIf="hasPermissions">Discard
            Changes</button>
        <span class="parsing-version"
            [attr.data-automation-id]="automationId + '-parsing-library-version-label'">Parsing Library Version:
            {{parsingLibraryVersion}}</span>
        <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
            (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>
    <form class="content" #contentForm="ngForm" [attr.data-automation-id]="automationId + '-content'"
        [resBusySpinner]="isBusy" [message]="isBusyMessage">

        <div class="file-types" [attr.data-automation-id]="automationId + '-all-supported-file-types-container'">
            <res-generic-grid [automationId]="'all-supported-file-types'" [pagerVisible]="false"
                [columnDefs]="supportedFileColumns" [headerTemplate]="supportedFileTypesHeaderTemplate"
                [headerHeight]="0" [rowClassRules]="rowDisableRules" [hasCustomCellTemplates]="true">
            </res-generic-grid>
            <ng-template #supportedFileTypesHeaderTemplate>
                <div class='parent-header'>
                    <span class="title">All Supported File Types</span>
                    <div class="filter" *ngIf="hasPermissions">
                        <res-filter #filterComponent [filterInputAutoId]="automationId"
                            [clearButtonDataAutoId]="automationId" [maxChars]=32 [placeholder]='"Filter ..."'
                            [callback]="filterData.bind(this)"></res-filter>
                    </div>
                </div>

            </ng-template>
        </div>

        <div class="vertical-spacer"></div>

        <div class="excluded-file-types" [attr.data-automation-id]="automationId + '-excluded-file-types-container'">
            <div class='parent-header'>
                <span>Excluded File Types</span>
                <div class="buttons" *ngIf="hasPermissions">
                    <button type="button" *ngIf="hasPermissions"
                        [attr.data-automation-id]="automationId + '-excluded-file-types-add-file-type-group-button'"
                        class="secondary-button" (click)="newGroupField()">
                        <i class="fa fa-plus sizing-icons"></i>Add File Type Group</button>
                </div>
            </div>
            <div class="list-container">
                <div *ngFor='let entry of excludedFileTypesFields; index as i; trackBy: trackByFn'>
                    <div class="list-item" dndDropzone (dndDrop)="onFieldDrop($event, entry)"
                        [dndDisableDropIf]="!isDragEnabled()" cdkDropList (cdkDropListDropped)="drop($event)"
                        [cdkDropListData]="entry.children">
                        <div class="input-container" [ngClass]="{'disabled': !hasPermissions}">
                            <input [attr.data-automation-id]="automationId + '-excluded-file-types-group-input'"
                                [disabled]="!hasPermissions" class="input-text" type="text"
                                [(ngModel)]="entry.externalName" name="entry.externalName_{{i}}"
                                [attr-data-automation-id]="'export-fields-list-item-fieldname-text-input-' + i">
                            <button type="button" class="remove-row" (click)="onRemoveRow(i)"
                                [attr.data-automation-id]="automationId + '-delete-button'" *ngIf="hasPermissions"
                                [tabindex]="excludeTrashBtnFromTabIndex ? -1 : 0"
                                [attr.data-automation-id]="automationId + '-excluded-group-types-delete-button'">
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                        <div class="item-children">
                            <div class="item-child drag-cell" cdkDrag [cdkDragDisabled]="!hasPermissions"
                                cdkDragPreviewContainer="parent" cdkDragBoundary=".list-item"
                                *ngFor='let child of entry.children; index as i; trackBy: trackByFn'
                                [attr.data-automation-id]="'excluded-file-types-list-item-child-' + i"
                                [ngClass]="{'disabled': !hasPermissions}">
                                <img class="drag-dots" src="assets/images/drag_grey.png" *ngIf="hasPermissions">
                                <span>{{child.name}}</span>
                                <button type="button" class="remove-row" (click)="onRemoveChild(i, entry)"
                                    [attr.data-automation-id]="automationId + '-delete-button'" *ngIf="hasPermissions"
                                    [tabindex]="excludeTrashBtnFromTabIndex ? -1 : 0"
                                    [attr.data-automation-id]="automationId + '-excluded-file-types-delete-button'">
                                    <i class="fa fa-trash-o" *ngIf="hasPermissions"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </form>
</div>